import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  baseURL: '',
})

export type Session = typeof authClient.$Infer.Session
